export default {
    created() {
        this.resolver = null;
        this.rejecter = null;
    },
    methods: {
        // INtendended public use via ref
        rejectOldPromise(reason) {
            if (this.rejecter) {
                this.rejecter(reason)
            }
            this.rejecter = null;
            this.resolver = null;
        },
        createPromise() {

            return new Promise((resolve, reject) => {
                this.resolver = resolve
                this.rejecter = reject
            })
        }
    }
}